export default "__VITE_ASSET__B5bbP9We__"